import { render, staticRenderFns } from "./IntroductionRequestForm.vue?vue&type=template&id=66f3a8d6"
import script from "./IntroductionRequestForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./IntroductionRequestForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports